import replaceSpecialCharacters from 'replace-special-characters';

import DateHelper from './DateHelper';

export default class TextHelper {
  static toString(str) {
    if ([undefined, null].includes(str)) {
      return '';
    }

    if (!Number.isNaN(str)) {
      return str.toString();
    }

    return `${str || ''}`;
  }

  static toMoney(value, preffix = 'R$ ') {
    value = (this.toString(value) || '0').replace(',', '.');
    value = parseFloat(value).toFixed(2).toString();

    return preffix + value.replace('.', ',');
  }

  static plain(str) {
    return this.toString(str).replace(/\W+/g, '');
  }

  static inline(str, replaceWith = ' ') {
    return this.toString(str).replace(/\r\n|\n|\r/g, replaceWith);
  }

  static escape(str) {
    return this.toString(str).replace(/"/g, '\\"').replace(/'/g, "\\'");
  }

  static firstLast(str, deflt = '') {
    const split = this.toString(str).split(' ');
    return `${split.shift()} ${split.pop()}`.trim() || deflt;
  }

  static upperFirst(str) {
    str = this.toString(str);
    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  static unmask(str, regex = /\W+/g) {
    return this.toString(str).replace(regex, '');
  }

  static mask(str, mask) {
    str = this.unmask(str);

    if (typeof mask === 'function') {
      mask = mask(str);
    }

    if (mask === 'date') {
      return DateHelper.toFormatString(str.substr(0, 8), 'dd/MM/yyyy');
    }

    if (mask === 'datetime') {
      return DateHelper.toFormatString(str.substr(0, 14), 'dd/MM/yyyy HH:mm:ss');
    }

    if (mask === 'money') {
      // Convert to number
      str = +str.replace(/\D/g, '');

      // Convert to string and pad 0 to start
      str = `${str}`.padStart(3, '0');

      // Apply ","
      str = `${str.slice(0, -2)},${str.substr(-2)}`;

      return str;
    }

    if (mask === 'cpf/cnpj') {
      mask = str.length > 11 ? 'cnpj' : 'cpf';
    }

    switch (mask) {
      case 'cep':
        mask = '##.###-###';
        break;
      case 'cnpj':
        mask = '##.###.###.####/##';
        break;
      case 'cpf':
        mask = '###.###.###-##';
        break;
      case 'phone':
        // Remover não-númericos e zeros à esquerda
        str = str.replace(/\D/g, '').replace(/^0+/, '');
        mask = str.length > 10 ? '(##) # ####-####' : '(##) ####-####';
        break;
      default:
        break;
    }

    let maskared = '';
    let sIndex = 0;

    for (let mIndex = 0; mIndex < mask.length; mIndex += 1) {
      if (!str[sIndex]) {
        break;
      }

      if (mask[mIndex] === '#') {
        maskared += str[sIndex];
        sIndex += 1;
      } else {
        maskared += mask[mIndex];
      }
    }

    return maskared;
  }

  static capitalize(str) {
    str = this.toString(str)
      .toLowerCase()
      .replace(/(^|\s)\S/g, (a) => a.toUpperCase())
      // Strings iniciadas em (, [ ou { devem manter a primeira letra maiúscula
      .replace(/[({[]\w/gi, (a) => a.toUpperCase())
      // Ignorar algumas palavras derivadas de "do" e "no"
      .replace(/\b([dn]?[aeiou]s?)\b/gi, (a) => a.toLowerCase())
      // Ignorar algumas palavras derivadas de "ao"
      .replace(/\b([a]?[o]s?)\b/gi, (a) => a.toLowerCase())
      // Ignorar algumas palavras derivadas de "para"
      .replace(/\b(pa?r[a|o])\b/gi, (a) => a.toLowerCase())
      // Ignorar "com"
      .replace(/\b(com)\b/gi, (a) => a.toLowerCase());

    return str.charAt(0).toUpperCase() + str.slice(1);
  }

  static replaceSpecialChars(str) {
    return replaceSpecialCharacters(this.toString(str));
  }
}
